import { Link } from "react-router-dom";
import { ShieldCheck, Lock, FileCheck2 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950/60 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 grid md:grid-cols-4 gap-8 text-sm text-slate-400">
        <div>
          <div className="inline-block bg-white rounded-xl px-3 py-2 mb-4">
            <img src="/vixvox-logo.png" alt="VixVox — A voz que sua empresa precisa ouvir e proteger" className="h-16 w-auto" data-testid="footer-logo" />
          </div>
          <p className="text-slate-500">Canal de denúncia corporativo. Sigilo absoluto, conformidade legal.</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-teal-400 mb-3">Produto</div>
          <ul className="space-y-2">
            <li><Link to="/vixvox" className="hover:text-white" data-testid="footer-sobre-link">Sobre a VixVox</Link></li>
            <li><a href="/#features" className="hover:text-white">Recursos</a></li>
            <li><a href="/#pricing" className="hover:text-white">Planos</a></li>
            <li><Link to="/acompanhar" className="hover:text-white">Acompanhar denúncia</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-teal-400 mb-3">Conformidade</div>
          <ul className="space-y-2">
            <li className="flex items-center gap-2"><FileCheck2 className="w-4 h-4 text-teal-400" /> NR-1 (MTE 1.419/2024)</li>
            <li className="flex items-center gap-2"><FileCheck2 className="w-4 h-4 text-teal-400" /> ISO 45003:2022</li>
            <li className="flex items-center gap-2"><FileCheck2 className="w-4 h-4 text-teal-400" /> Lei 14.831/2024</li>
            <li className="flex items-center gap-2"><FileCheck2 className="w-4 h-4 text-teal-400" /> Lei 14.457/2022 (CIPAA)</li>
            <li className="flex items-center gap-2"><Lock className="w-4 h-4 text-teal-400" /> ISO/IEC 27001</li>
            <li className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-teal-400" /> LGPD</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-teal-400 mb-3">Legal</div>
          <ul className="space-y-2">
            <li><Link to="/privacidade" className="hover:text-white" data-testid="footer-privacy-link">Política de Privacidade</Link></li>
            <li><Link to="/termos" className="hover:text-white" data-testid="footer-terms-link">Termos de Uso</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-slate-500">
          <div className="space-y-1">
            <div className="text-slate-300 font-medium" data-testid="footer-legal-name">CHIESA CARVALHO TREINAMENTOS LTDA - ME (GESTÃO &amp; GENTE)</div>
            <div>CNPJ 19.815.358/0001-09 · <a href="mailto:contato@vixvitae.com.br" className="text-teal-400 hover:underline" data-testid="footer-contact-email">contato@vixvitae.com.br</a> · <a href="https://wa.me/5543988207979" target="_blank" rel="noreferrer" className="text-teal-400 hover:underline" data-testid="footer-whatsapp">WhatsApp (43) 9 8820-7979</a></div>
          </div>
          <div>© {new Date().getFullYear()} vixvox — Todos os direitos reservados.</div>
        </div>
      </div>
    </footer>
  );
}
